/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { HorizontalData, PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useCommunities } from "../../store/useCommunities";
import { useEffect, useState } from "react";
import { CommunitiesTable } from "./CommunitiesTable";

function CommunityScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const {
    communities,
    getCommunities,
    hasNextPage,
    communityStats,
    getCommunityStats,
  } = useCommunities();
  /** State */
  const [page, setPage] = useState<number>(1);

  /** Effects */
  useEffect(() => {
    getCommunities(1, 100);
    getCommunityStats();
  }, []);

  /** Callbacks */
  const addCommunity = () => navigate(`/add-community`);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-5 sm:mb-11">
          Communities
        </h1>
        <PrimaryButton
          label="Add new"
          onClick={addCommunity}
          className="h-10"
        />
      </div>
      {/* Top Stats */}
      <HorizontalData
        data={[
          {
            label: "Total amount of users that donated",
            value: communityStats?.userCount ?? 0,
          },
          {
            label: "Total amount of donations made",
            value: communityStats?.donationsCount ?? 0,
          },
          {
            label: "Total amount donated to communities",
            value: `€${Number(
              Number(communityStats?.totalAmountDonated ?? 0) / 100
            )?.toFixed(2)}`,
          },
        ]}
      />
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!communities?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no community created yet.
          </p>
        ) : (
          <CommunitiesTable />
        )}
      </div>
      {hasNextPage ? (
        <div className="flex flex-row w-full items-center justify-end mt-3">
          <PrimaryButton
            onClick={() => {
              setPage(page + 1);
              getCommunities(page + 1, 10);
            }}
            label="Load more"
            className="h-10"
          />
        </div>
      ) : null}
    </div>
  );
}

export default withProtectedRoute(CommunityScreen);
